import accident from 'assets/images/svg/new-plan/discover/accident.svg';
import robbery from 'assets/images/svg/new-plan/discover/robbery.svg';
import damage from 'assets/images/svg/new-plan/discover/damage.svg';
import personalAccident from 'assets/images/svg/new-plan/discover/personal-accident.svg';

export const DISCOVER_FULL_HIGH = [
    {
        id: 1,
        title: 'Protege tu carro frente un robo total',
        subTitle: 'Si tu carro es robado y no lo recuperas, te devolvemos 100% de su valor.',
        img: robbery
    },
    {
        id: 2,
        title: 'Accidentes personales',
        subTitle: 'En caso de un choque cubrimos los gastos médicos o de sepelio de los pasajeros.',
        img: personalAccident
    },
    {
        id: 3,
        title: 'Pago por choques',
        subTitle: 'Sabías que a cada hora ocurren 10 accidentes de tránsito. Si chocas, te damos hasta S/1000 por dos eventos al año.',
        img: accident

    },
    {
        id: 4,
        title: 'Daños a terceros',
        subTitle: '¡No te preocupes! Podrás responder por daños en la propiedad de algún tercero afectado por el choque.',
        img: damage

    }
]